/** @file tileRequestClose: closes a Tile tab, or shows it and asks Save / Discard / Cancel when unsaved. */
import { routePuppet } from '../../shell/routePuppet';
import type { EditorStore, TileRef } from '../../state/editorTypes';
import { tileDraftKey } from './tileDraftKey';
import { tileDrafts } from './tileDrafts';

/**
 * A tab without unsaved strokes closes at once (its draft is dropped); a dirty one is shown (`openTile`) and its
 * screen asks through the `close` prompt (the screen owns the server calls Save needs). The top bar's ×, a middle
 * click and the close key all come here.
 */
export function tileRequestClose(store: EditorStore, ref: TileRef): void {
  const s = store.getState();
  const puppetId = routePuppet(s.route) ?? s.puppet.id;
  if (puppetId === null) return;
  const key = tileDraftKey(puppetId, ref);
  const drafts = tileDrafts.getState();
  const d = drafts.drafts[key];
  if (d !== undefined && d.version !== d.savedVersion) {
    s.openTile(ref);
    drafts.setPrompt({ kind: 'close', key });
    return;
  }
  drafts.discard(key);
  s.closeTile(ref);
}
